import MuiSwitch, { type SwitchProps } from "@mui/material/Switch";

export type { SwitchProps };

export function Switch(props: SwitchProps) {
  return <MuiSwitch {...props} />;
}
